import React from "react";
import { Tooltip } from "@mui/material";

export default function truncate(content, length, truncationSymbol = "...") {
	const string = content + "";
	if (string.length <= length) {
		return string;
	}
	return (
		<Tooltip title={string} placement="top">
			<span>
				{string.slice(0, length) + truncationSymbol}
			</span>
		</Tooltip>
	);
}
